import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import snowflakeSvg1 from './blue-bold.svg';
import snowflakeSvg2 from './blue-light.svg';
// import snowflakeSvg3 from './Snowflake Icon.svg'
import Snowfall from 'react-snowfall';
export const Snow = () => {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [snowflakes, setSnowflakes] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const img1 = document.createElement("img");
      img1.onload = () => setSnowflakes(prev => [...prev, img1]);
      img1.onerror = () => setSnowflakes([]);
      img1.src = snowflakeSvg1.src;
      const img2 = document.createElement("img");
      img2.onload = () => setSnowflakes(prev_0 => [...prev_0, img2]);
      img2.onerror = () => setSnowflakes([]);
      img2.src = snowflakeSvg2.src;
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!snowflakes.length) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [2, 12];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== snowflakes) {
    t4 = <Snowfall radius={t3} images={snowflakes} />;
    $[4] = snowflakes;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};